module.exports = __webpack_public_path__ + "img/4_89.c112bbb4.png";